import { createTypes } from '../../utils/helpers';

const GET_SPECIAL_EVENT_REASONS: any = createTypes('GET_SPECIAL_EVENT_REASONS');
const HEALTH_CHECK_MDS: any = createTypes('HEALTH_CHECK_MDS');
const SHOW_HOLIDAYS = 'SHOW_HOLIDAYS';
const SET_SELECTED_START_DATE = 'SET_SELECTED_START_DATE';
const SET_SELECTED_RANGE_DATE = 'SET_SELECTED_RANGE_DATE';
const SET_SPECIAL_EVENT_DATA = 'SET_SPECIAL_EVENT_DATA';
const SET_SPECIFIC_SPECIAL_EVENT_DATA = 'SET_SPECIFIC_SPECIAL_EVENT_DATA';
const SET_OPEN_24HOURS_TO_ALL = 'SET_OPEN_24HOURS_TO_ALL';
const SET_CLOSE_TO_ALL = 'SET_CLOSE_TO_ALL';
const CLEAR_FORM = 'CLEAR_FORM';
const CLEAR_TIMETABLE = 'CLEAR_TIMETABLE';
const SET_IS_LOADING: any = createTypes('SET_IS_LOADING');
const CREATE_SPECIAL_EVENT: any = createTypes('CREATE_SPECIAL_EVENT');
const GET_DELIVERY_HOURS: any = createTypes('GET_DELIVERY_HOURS');
const GET_MASS_UPLOAD_FILE: any = createTypes('GET_MASS_UPLOAD_FILE');
const TOGGLE_12H_FORMAT: any = 'TOGGLE_12H_FORMAT';
const SET_12H_FORMAT: any = 'SET_12H_FORMAT';
const GET_SINGLE_RESTAURANT_WEEK_HOURS: any = createTypes(
  'GET_SINGLE_RESTAURANT_WEEK_HOURS',
);
const GET_SPECIAL_EVENT_DAY_BY_DAY: any = createTypes(
  'GET_SPECIAL_EVENT_DAY_BY_DAY',
);
const TOGGLE_OPERATION_HOURS_VIEW_MODE = 'TOGGLE_OPERATION_HOURS_VIEW_MODE';
const SET_RECENTLY_EDITED_BASE_HOURS = 'SET_RECENTLY_EDITED_BASE_HOURS';
const CLEAR_RECENTLY_EDITED_BASE_HOURS = 'CLEAR_RECENTLY_EDITED_BASE_HOURS';

export {
  GET_SPECIAL_EVENT_REASONS,
  HEALTH_CHECK_MDS,
  SHOW_HOLIDAYS,
  SET_SELECTED_START_DATE,
  SET_SELECTED_RANGE_DATE,
  SET_SPECIAL_EVENT_DATA,
  SET_SPECIFIC_SPECIAL_EVENT_DATA,
  SET_OPEN_24HOURS_TO_ALL,
  SET_CLOSE_TO_ALL,
  CREATE_SPECIAL_EVENT,
  CLEAR_FORM,
  CLEAR_TIMETABLE,
  SET_IS_LOADING,
  GET_DELIVERY_HOURS,
  GET_MASS_UPLOAD_FILE,
  TOGGLE_12H_FORMAT,
  SET_12H_FORMAT,
  GET_SINGLE_RESTAURANT_WEEK_HOURS,
  GET_SPECIAL_EVENT_DAY_BY_DAY,
  TOGGLE_OPERATION_HOURS_VIEW_MODE,
  SET_RECENTLY_EDITED_BASE_HOURS,
  CLEAR_RECENTLY_EDITED_BASE_HOURS,
};
